import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
//import registerServiceWorker from './registerServiceWorker';
import { createStore } from "redux";
import { Provider } from "react-redux";
import reducer from "./reducers/reducer";

const store = createStore(reducer);

store.dispatch({
  type: "SET_STATE",
  state: {
    frameProducts: [],
    productsCount: 0,
    frameCategories: [],
    displayCategory: 16,
    catProCount: 0,
    frameLoading: true,
    selectedFrame: [],
    frameTotal: 0,
    frameSizeH: 0,
    frameSizeW: 0,
    frameFullDimension: 0,
    canvasImage: null,
    canvasThumbImage: null,
    imageSizeError: false,

    glasses: [],
    selectedGlass: null,
    glassTotal: 0,
    selectedGlassName: null,

    printing: [],
    selectedPrint: null,
    printTotal: 0,
    selectedPrintName: null,
    matPrint: [],

    wallcolor: "#f7f7f7",

    roomImages: [],
    selectedRoomImage: [],

    mats: [],
    matView: 1,
    selectedMatSize: 1,
    selectedTopMat: [],
    selectedMiddleMat: [],
    middleMatTotal: 0,
    matsLoaded: false,
    matsUpdated: 0,

    qty: 1,
    cartQty: 0,
    customizeQTY: 0,
    cart1ItemTotal: 0,
    selectedTab: "layout",

    viewportWidth: 0,
    viewportHeight: 0,
    rightFrameHeight: 0,
    headerHeight: 0,
    leftWidth: 0,

    matWindowValues: [],
    matBoards: [],
    selectedmatBoard: [],
    matBoardPrice: 0,
    matBoardWindowSize: 0,
    windowSizes: [],
    middleMatGapInCM: 0.5,
    windowDimensionW: 0,
    windowDimensionH: 0,
    windowsFullDimension: 0,
    matOuterWidth: 0,
    matOuterHeight: 0,
    matOuterUpdated: 0,
    matUpdated: 0,
    matWindowUpdated: 0,
    updatingWindow: 0,
    isGrid: false,
    displayCategoryMatt: 69,
    catMattProCount: 0,
    mattProductsCount: 0,
    matCategories: [],

    plaqueValues: {},
    plaqueUpdated: 0,
    plaqueError: false,
    plaqueColour: "#DAA520",
    plaqueSize: "large",
    plaqueTotal: 0,
    matPlauqeValues: [],

    showMeHow: false,
    equalSpacing: false
  }
});

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
//registerServiceWorker();
